export const environment = {
  production: true,
  serviceWorkerScript: 'sw-master.js'
};
